import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=29125f04&scoped=true&"
import script from "./appointment.vue?vue&type=script&lang=js&"
export * from "./appointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29125f04",
  null
  
)

export default component.exports